import React, { useState } from "react";
import "./Skills.css";

const Skills = () => {
  const [openCategories, setOpenCategories] = useState({
    languages: false,
    libraries: false,
    software: false,
    softSkills: false
  });

  const toggleCategory = (category) => {
    setOpenCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const skillsData = [
    {
      id: 'languages',
      title: 'Languages',
      skills: ['Python', 'JavaScript', 'SQL']
    },
    {
      id: 'libraries',
      title: 'Libraries/Packages',
      skills: ['React', 'NodeJs', 'Express', 'Mongoose', 'pg', 'Flask', 'Django', 'Tensorflow', 'Remix', 'PrismaORM']
    },
    {
      id: 'software',
      title: 'Software',
      skills: ['Postman', 'Hoppscotch', 'MongoCompass', 'PgAdmin', 'Git', 'GitHub', 'Vercel', 'Render', 'Glitch', 'Supabase']
    },
    {
      id: 'softSkills',
      title: 'Soft Skills',
      skills: ['Communication and Community Building', 'Collaboration', 'Adaptability']
    }
  ];

  return (
    <>
      <section className="skills-section">
        <h2 className="section-title">Technologies and Skills</h2>
        <div className="skills-container">
          {skillsData.map((category) => (
            <div key={category.id} className="skill-category">
              <div 
                className="skill-category-header"
                onClick={() => toggleCategory(category.id)}
              >
                <h3>{category.title}</h3>
                <span className={`toggle-icon ${openCategories[category.id] ? 'open' : ''}`}>
                  ▼
                </span>
              </div>
              <ul className={`skill-list ${openCategories[category.id] ? 'open' : ''}`}>
                {category.skills.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Skills;
